import { render, staticRenderFns } from "./VerticalBar.vue?vue&type=template&id=2221ef4d&scoped=true"
import script from "./VerticalBar.vue?vue&type=script&lang=ts"
export * from "./VerticalBar.vue?vue&type=script&lang=ts"
import style0 from "./VerticalBar.vue?vue&type=style&index=0&id=2221ef4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2221ef4d",
  null
  
)

export default component.exports